/**
 * Swedish copy for share prompt cards.
 * Maps prompt_type → headline + description.
 */

import type { SharePromptType } from './types';

interface PromptCopy {
  headline: (title: string) => string;
  description: string;
  ctaLabel: string;
}

const PROMPT_COPY: Record<SharePromptType, PromptCopy> = {
  publish: {
    headline: (title) => `"${title}" är live!`,
    description: 'Dela med dina följare att aktiviteten finns att boka.',
    ctaLabel: 'Skapa inlägg',
  },
  reminder: {
    headline: (title) => `Snart dags för "${title}"`,
    description: 'Påminn dina följare — det är bara några dagar kvar.',
    ctaLabel: 'Skapa inlägg',
  },
  last_spots: {
    headline: (title) => `Bara några platser kvar till "${title}"`,
    description: 'Skapa FOMO — dela att det snart är fullbokat.',
    ctaLabel: 'Skapa inlägg',
  },
  tomorrow: {
    headline: (title) => `Imorgon: "${title}"`,
    description: 'Sista chansen att nå fler — dela en påminnelse.',
    ctaLabel: 'Skapa inlägg',
  },
};

export function getPromptCopy(promptType: SharePromptType, entityTitle: string) {
  const copy = PROMPT_COPY[promptType];
  return {
    headline: copy.headline(entityTitle),
    description: copy.description,
    ctaLabel: copy.ctaLabel,
  };
}
